export var TypeActionPlayerProfile;
(function (TypeActionPlayerProfile) {
    TypeActionPlayerProfile["SetCurrentPlayerProfile"] = "PlayerProfile > SetCurrentPlayerProfile";
    TypeActionPlayerProfile["RemoveCurrentPlayerProfile"] = "PlayerProfile > RemoveCurrentPlayerProfile";
    TypeActionPlayerProfile["OpenOwnPlayerProfile"] = "PlayerProfile > OpenOwnPlayerProfile";
    TypeActionPlayerProfile["OpenOtherPlayerProfile"] = "PlayerProfile > OpenOtherPlayerProfile";
})(TypeActionPlayerProfile || (TypeActionPlayerProfile = {}));
export var actionSetCurrentPlayerProfile = function (id, level, name, profileIcon, playerLeagueId, coopInfo) { return ({
    coopInfo: coopInfo,
    id: id,
    level: level,
    name: name,
    playerLeagueId: playerLeagueId,
    profileIcon: profileIcon,
    type: TypeActionPlayerProfile.SetCurrentPlayerProfile,
}); };
export var actionRemoveCurrentPlayerProfile = function () { return ({
    type: TypeActionPlayerProfile.RemoveCurrentPlayerProfile,
}); };
export var actionOpenOwnPlayerProfile = function () { return ({
    type: TypeActionPlayerProfile.OpenOwnPlayerProfile,
}); };
export var actionOpenOtherPlayerProfile = function (id) { return ({
    id: id,
    type: TypeActionPlayerProfile.OpenOtherPlayerProfile,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/player-profile/actionPlayerProfile.ts
// module id = 298
// module chunks = 3